import config from "@/config";
import { oidcUserStore } from "@/provider/AuthProvider/oidcUserStore";
import { UserManager } from "oidc-client-ts";

// Shared UserManager for react-oidc-context. Token exchange/refresh use silentTokenRefresh.ts
// because the library cannot send Trimble Serial PKCE fields on /oauth/token.
// userStore is in-memory; sign-in state still uses sessionStorage for the Trimble redirect.
export const userManager = new UserManager({
  ...config.oidc,
  userStore: oidcUserStore,
  redirect_uri: `${window.location.origin}/callback`,
  response_type: "code",
  silent_redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: window.location.origin,
  monitorSession: true,
  includeIdTokenInSilentRenew: true,
  loadUserInfo: true,
  response_mode: "query",
  scope: config.oidc.scope ?? "openid BSG-DXP iam TCMiddleware-Dev",
  // Library silent renew omits Serial PKCE; useTokenRefresh replaces it.
  automaticSilentRenew: false,
});

export function isIdleLogoutCallback(): boolean {
  return window.location.pathname.endsWith("/logout");
}
